export const iconFontAwesomeEducationSchool = (
	<i className="fa-solid fa-school"></i>
);
